import React, { useState } from "react";
import { RxCross2 } from "react-icons/rx";

type ViewRecordButtonProps = {
  children: React.ReactNode;
  buttonText: string;
  buttonClassName?: string;
  size?: 1 | 2 | 3 | 4 | 5;
  disableCloseButton?: boolean;
};

const ActionModal = ({
  children,
  buttonClassName,
  buttonText,
  size = 1,
  disableCloseButton = false,
}: ViewRecordButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const maxWidthClass = size === 1 ? "max-w-xl" : `max-w-${size}xl`;

  return (
    <div>
      <button
        onClick={() => setIsOpen(true)}
        className={
          buttonClassName || "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded cursor-pointer"
        }
      >
        {buttonText}
      </button>

      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 p-3 sm:p-4">
          <div className={`flex max-h-[calc(100vh-2rem)] w-full flex-col overflow-hidden rounded-xl bg-white ${maxWidthClass}`}>
            <div className="flex-shrink-0 p-5 pb-3 text-left">
              <button
                onClick={() => setIsOpen(false)}
                className="text-3xl text-gray-400 hover:text-gray-700 text-xl font-bold leading-none font-size cursor-pointer"
                aria-label="Close"
              >
                <RxCross2 />
              </button>
            </div>
            <div className="min-h-0 flex-1 overflow-y-auto px-5 pb-5">{children}</div>
            {!disableCloseButton && (
              <div className="flex flex-shrink-0 justify-end border-t border-gray-200 p-4 sm:p-6">
                <button
                  onClick={() => setIsOpen(false)}
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors cursor-pointer"
                >
                  Close
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ActionModal;
